<template>
  <el-card>
    <div class="tab-header">
      <span>회차 타임라인</span>
    </div>

    <el-timeline v-if="rounds.length > 0">
      <el-timeline-item
        v-for="round in sortedRounds"
        :key="round.id"
        :type="getRoundTimelineType(round)"
        :hollow="round.status === 'PREPARING'"
        :timestamp="`${round.round_number}차 - ${round.status_display || round.status}`"
        placement="top"
      >
        <el-card
          shadow="hover"
          :class="{ 'selected-round': selectedRoundId === round.id }"
          @click="$emit('select-round', round)"
          style="cursor: pointer;"
        >
          <div class="round-card-content">
            <div class="round-info">
              <el-tag :type="getRoundStatusType(round.status)" size="small">
                {{ round.status_display || round.status }}
              </el-tag>
              <el-tag v-if="round.result && round.result !== 'PENDING'" :type="getResultType(round.result)" size="small" style="margin-left: 5px;">
                {{ round.result_display || round.result }}
              </el-tag>
            </div>
            <div class="round-meta" v-if="round.reviewer_name || round.review_comments">
              <span v-if="round.reviewer_name">검토자: {{ round.reviewer_name }}</span>
              <span v-if="round.review_comments"> | {{ round.review_comments }}</span>
            </div>
            <div class="round-dates">
              <span>생성: {{ formatDate(round.created_at) }}</span>
              <span v-if="round.reviewed_at"> | 검토: {{ formatDate(round.reviewed_at) }}</span>
            </div>
          </div>
        </el-card>
      </el-timeline-item>
    </el-timeline>

    <el-empty v-else description="회차 정보가 없습니다." />
  </el-card>
</template>

<script setup>
import { computed, ref } from 'vue'

const props = defineProps({
  rounds: { type: Array, default: () => [] },
  sampleRequest: { type: Object, default: () => ({}) },
  loading: Boolean
})

defineEmits(['refresh', 'select-round'])

const selectedRoundId = ref(null)

const sortedRounds = computed(() => {
  return [...props.rounds].sort((a, b) => b.round_number - a.round_number)
})

const getRoundTimelineType = (round) => {
  const map = { COMPLETED: 'success', CANCELLED: 'danger', IN_PROGRESS: 'primary', REVIEW: 'warning', PREPARING: 'info' }
  return map[round.status] || 'info'
}

const getRoundStatusType = (status) => {
  const map = { PREPARING: 'info', IN_PROGRESS: '', REVIEW: 'warning', COMPLETED: 'success', CANCELLED: 'danger' }
  return map[status] || 'info'
}

const getResultType = (result) => {
  const map = { ACCEPTED: 'success', REVISION_NEEDED: 'warning', REJECTED: 'danger', PENDING: 'info' }
  return map[result] || 'info'
}

const formatDate = (dateStr) => {
  if (!dateStr) return '-'
  return dateStr.substring(0, 10)
}
</script>

<style scoped>
.tab-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.tab-header span {
  font-size: 16px;
  font-weight: 600;
}

.round-card-content {
  font-size: 13px;
}

.round-info {
  margin-bottom: 5px;
}

.round-meta {
  color: #606266;
  margin-bottom: 3px;
}

.round-dates {
  color: #909399;
  font-size: 12px;
}

.selected-round {
  border: 2px solid #409eff;
}
</style>
